import { AssetDto } from "../dtos/assetDto";
import { Asset } from "../models/asset";
import { BigNumber } from "../models/bigNumbers";
import ApiService from "../services/api";
import { fetchComplementaryAssetsDetails } from "./fetchAssets";
import { fetchVehiclesFromOccurrences } from "./fetchVehiclesFromOccurrences";

export interface IAssetSummary {
  id: string;
  identification: string;
  name: string;
}

let cancelAbortController: AbortController | undefined;
export const fetchMaintenance = async (assetsSummary: IAssetSummary[]): Promise<[Asset[], BigNumber?]> => {
  if(cancelAbortController) cancelAbortController.abort();
  cancelAbortController = new AbortController();

  if(!assetsSummary || assetsSummary?.length === 0) {
    cancelAbortController = undefined;
    return [[], undefined];
  }

  const apiService = new ApiService();

  try {
    const response = await apiService.post<any>(`/maintenance`, {assets: assetsSummary}, { signal: cancelAbortController.signal });
    if (response.status === 200) {
      const maintenanceList = response.data.list || [];

      const assetIds = maintenanceList.map((el: any) => el.vehicle?.assetId).filter(Boolean);
      const chassisList = maintenanceList.map((el: any) => el.vehicle?.chassis).filter(Boolean);

      const [complementaryDetails, vehiclesFromOccurrences] = await Promise.all([
        assetIds.length ? fetchComplementaryAssetsDetails(assetIds) : Promise.resolve([]),
        chassisList.length ? fetchVehiclesFromOccurrences(chassisList) : Promise.resolve([]),
      ]);

      const assets = maintenanceList.map((el: any) => {
        const assetSummary = assetsSummary.find((asset: IAssetSummary) => asset.id === el.vehicle.assetId);
        const complementary = complementaryDetails.find((c: any) => c.id === el.vehicle.assetId);
        const occurrenceVehicle = vehiclesFromOccurrences.find((v: any) => v.chassis === (el.vehicle?.chassis || assetSummary?.identification));

        const plateFromPayload = el.vehicle?.plate;
        const plateFromComplementary = complementary?.licensePlate;
        const plateFromOccurrence = occurrenceVehicle?.licensePlate;

        const finalPlate = (plateFromPayload && plateFromPayload !== '-')
          ? plateFromPayload
          : (plateFromComplementary && plateFromComplementary !== '-')
            ? plateFromComplementary
            : (plateFromOccurrence && plateFromOccurrence !== '-')
              ? plateFromOccurrence
              : undefined;

        const vehicleWithPlate = {
          ...el.vehicle,
          chassis: assetSummary?.identification || el.vehicle?.chassis,
          name: assetSummary?.name || el.vehicle?.name,
          plate: finalPlate !== undefined ? finalPlate : el.vehicle?.plate,
        };

        return AssetDto({
          ...el,
          vehicle: vehicleWithPlate,
          previousCheckups: null,
          nextCheckups: null,
        });
      });
      cancelAbortController = undefined;
      return [
        assets,
        //BigNumberDto(response.data.bigNumbers, assets)
      ];
    } else {
      cancelAbortController = undefined;
      return [[]];
    }
  } catch (error: any) {
    if(error.code === "ERR_CANCELED") throw new Error("ERR_CANCELED");
    cancelAbortController = undefined;
    console.error(error);
    return [[]];
  }
};
